import { Link } from "react-router-dom";
import Nav from "../components/Nav";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#F4F7F6]">
      <Nav />
      <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="payment-cancel">
        <h1 className="font-display text-3xl text-slate-800">No worries — nothing was charged.</h1>
        <p className="text-slate-600 mt-2">Whenever you're ready, Zaf's still here.</p>
        <div className="mt-8 flex items-center justify-center gap-4">
          <Link
            to="/billing"
            data-testid="cancel-to-billing"
            className="bg-[#2E9D96] hover:bg-[#1F7B75] text-white font-semibold px-7 py-3 rounded-full transition-colors"
          >
            Back to billing
          </Link>
          <Link to="/chat" className="text-slate-600 hover:text-[#2E9D96] font-semibold transition-colors">
            Go to chat
          </Link>
        </div>
      </div>
    </div>
  );
}
